// extracted by mini-css-extract-plugin
module.exports = {"filter":"_45a789d","text":"_51aaa09","label":"_ee4459b"};